import React from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';

import { Link, Tag, Flexer } from '@ontruck/orc';

import { compose, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';

const getCompanyName = ({ stops, cargo_manifest: { origin_stop, destination_stop } }) => {
  const stop = stops[origin_stop || destination_stop] || {};
  const { address: { company_name = '' } = {} } = stop;

  return company_name.length > 35 ? company_name.slice(0, 35).concat('...') : company_name;
};

const enhance = compose(
  withHandlers({
    handleUploadClick:
      ({ onUploadClick, stopId }) =>
      ({ cargo_id }) =>
        onUploadClick && onUploadClick({ stop_id: stopId, cargo_id }),
    handleDeteleClick:
      ({ onDeleteClick, stopId }) =>
      ({ cargo_id }) =>
        onDeleteClick && onDeleteClick({ stop_id: stopId, cargo_id }),
  })
);

const DONE_STATUSES = ['DONE', 'DONE_WITHOUT_MANIFEST', 'CANCELLED'];

const CargoManifestRow = React.memo(
  ({ stops, stop, handleUploadClick, handleDeteleClick, item, intl }) => {
    const t = intl.messages.components.StopCard;
    const itemIsShipperOrder = !!item.journeys;

    return (
      ((itemIsShipperOrder && item.status === 'DONE') || DONE_STATUSES.includes(stop.status)) && (
        <StyledRow>
          {stop.status !== 'CANCELLED' &&
            stop.cargo_manifests.map((cargo_manifest, key) =>
              cargo_manifest.cargo_manifest_url ? (
                <Flexer.Parent alignItems="center" key={key}>
                  <Flexer.Child flexGrow="1" pRight="XS">
                    <Link
                      link
                      href={cargo_manifest.cargo_manifest_url}
                      text={`${t.cargo_manifest_see} ${getCompanyName({ stops, cargo_manifest })}`}
                      skin="secondary"
                      weight="bold"
                      noWrap
                      target="_blank"
                    />
                  </Flexer.Child>
                  <Flexer.Child>
                    {!item.journeys && (
                      <Link
                        weight="bold"
                        skin="secondary"
                        text={t.delete_cargo_manifest}
                        onClick={() => handleDeteleClick({ cargo_id: key })}
                      />
                    )}
                  </Flexer.Child>
                </Flexer.Parent>
              ) : (
                <Flexer.Parent alignItems="center" key={key}>
                  <Flexer.Child flexGrow="1" pRight="S" overflowHidden>
                    <Tag skin="red" weight="bold" noWrapAndOverflow>
                      {t.missing} S{cargo_manifest?.shipper_order_id}{' '}
                      {getCompanyName({ stops, cargo_manifest })}
                    </Tag>
                  </Flexer.Child>
                  <Flexer.Child>
                    {!item.journeys && (
                      <Link
                        link
                        text={t.cargo_manifest_upload}
                        weight="bold"
                        onClick={() => handleUploadClick({ cargo_id: key })}
                      />
                    )}
                  </Flexer.Child>
                </Flexer.Parent>
              )
            )}
        </StyledRow>
      )
    );
  }
);

CargoManifestRow.propTypes = {
  stops: PropTypes.array,
  stop: PropTypes.object,
  stopId: PropTypes.number,
  onUploadClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};

export default enhance(injectIntl(CargoManifestRow));
